export interface IDispositivo {
  sistemaOperacional: string;
  modeloDispositivo: string;
  isMobile: boolean;
}

const detectarSO = (ua: string): string => {
  const uaLower = ua.toLowerCase();

  if (uaLower.includes('windows nt 10.0')) return 'Windows 10/11';
  if (uaLower.includes('windows nt 6.3')) return 'Windows 8.1';
  if (uaLower.includes('windows nt 6.1')) return 'Windows 7';
  if (uaLower.includes('windows')) return 'Windows';
  if (uaLower.includes('android')) {
    const versao = uaLower.match(/android\s([\d.]+)/)?.[1] || '';
    return versao ? `Android ${versao}` : 'Android';
  }
  if (uaLower.includes('iphone')) return 'iOS (iPhone)';
  if (uaLower.includes('ipad')) return 'iOS (iPad)';
  if (uaLower.includes('mac os')) return 'macOS';
  if (uaLower.includes('linux')) return 'Linux';
  return 'Desconhecido';
};

const detectarModelo = (ua: string): string => {
  const uaLower = ua.toLowerCase();

  const nomesModelos: { chave: string; nome: string }[] = [
    { chave: 'iphone', nome: 'Apple iPhone' },
    { chave: 'ipad', nome: 'Apple iPad' },
    { chave: 'samsung', nome: 'Samsung' },
    { chave: 'redmi', nome: 'Xiaomi Redmi' },
    { chave: 'poco', nome: 'Xiaomi POCO' },
    { chave: 'xiaomi', nome: 'Xiaomi' },
    { chave: 'huawei', nome: 'Huawei' },
    { chave: 'oneplus', nome: 'OnePlus' },
    { chave: 'mot', nome: 'Motorola' },
    { chave: 'lg', nome: 'LG' },
  ];

  const segmento = ua.split('(')[1]?.split(')')[0];
  const partes =
    (segmento &&
      segmento
        .split(';')
        .map(item => item.trim())
        .filter(Boolean)) ||
    [];

  const encontrado = nomesModelos.find(modelo =>
    uaLower.includes(modelo.chave),
  );

  if (encontrado) {
    const item = partes.find(p => p.toLowerCase().includes(encontrado.chave));
    if (item) return item.replace(/build\//i, '').trim();
    return encontrado.nome;
  }
  return '';
};

export function detectarDispositivo(): IDispositivo {
  if (typeof navigator === 'undefined') {
    return {
      sistemaOperacional: '',
      modeloDispositivo: '',
      isMobile: false,
    };
  }

  const ua = navigator.userAgent;

  return {
    sistemaOperacional: detectarSO(ua),
    modeloDispositivo: detectarModelo(ua),
    isMobile: /android|iphone|ipad|mobile/i.test(ua),
  };
}

export default detectarDispositivo;
